import { useState } from "react";
import { Play } from "lucide-react";
import { useApi } from "@/lib/api";
import { Container, PageHeader } from "@/components/site/PageHeader";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const thumb = (id) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;

const TrackRow = ({ t, onPlay }) => (
  <li className="group grid grid-cols-[56px_96px_1fr_auto] md:grid-cols-[80px_160px_1fr_auto] items-center gap-4 md:gap-8 py-5 border-b border-white/10" data-testid={`track-row-${t.rank}`}>
    <span className="font-display text-4xl md:text-6xl text-white/20 group-hover:text-primary transition-colors">{String(t.rank).padStart(2, "0")}</span>
    <div className="aspect-video overflow-hidden bg-[hsl(var(--surface))]">
      {t.youtube_id && <img src={thumb(t.youtube_id)} alt={t.title} loading="lazy" className="w-full h-full object-cover" />}
    </div>
    <div className="min-w-0">
      <p className="font-display uppercase text-xl md:text-3xl text-white leading-none truncate">{t.title}</p>
      <p className="text-zinc-400 text-sm mt-1 truncate">{t.artist}</p>
    </div>
    {t.youtube_id ? (
      <button onClick={() => onPlay(t)} data-testid={`track-play-${t.rank}`} aria-label={`Écouter ${t.title}`} className="w-12 h-12 border border-white/30 text-white flex items-center justify-center hover:bg-primary hover:border-primary transition-colors duration-200">
        <Play className="w-5 h-5" />
      </button>
    ) : <span className="w-12" />}
  </li>
);

export default function Arrivages() {
  const { data = [] } = useApi("/arrivages");
  const [active, setActive] = useState(null);
  return (
    <>
      <PageHeader top="Arrivages" bottom="en playlist" testId="arrivages-header"
        intro="Les dernières entrées dans la playlist de la radio LGTDZ." />
      <Container className="py-12">
        <ol data-testid="arrivages-list">{data.map((t) => <TrackRow key={t.id} t={t} onPlay={setActive} />)}</ol>
      </Container>
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="rounded-none bg-black border-white/10 max-w-4xl p-0 overflow-hidden" data-testid="track-video-dialog">
          <DialogTitle className="font-display uppercase text-2xl px-6 pt-6 text-white">{active?.title} — <span className="text-primary">{active?.artist}</span></DialogTitle>
          {active && (
            <div className="aspect-video">
              <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${active.youtube_id}?autoplay=1`} title={active.title} allow="autoplay; encrypted-media" allowFullScreen />
            </div>
          )}
          {active && (
            <a href={`https://www.youtube.com/watch?v=${active.youtube_id}`} target="_blank" rel="noreferrer" data-testid="track-open-youtube" className="px-6 pb-6 text-xs uppercase tracking-[0.2em] font-bold text-zinc-400 hover:text-primary transition-colors">
              Vidéo bloquée ? Ouvrir sur YouTube ↗
            </a>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
